<template>
    <div class="card card-round shadow dashboard-widget dashboard-widget--quotation quotation-widget"  >
        <div class="card-header d-flex justify-content-between mb-0 quotation-widget__header">
            <h6 class="mb-0 fw-bold dashboard-widget__title">
                <span class="dashboard-widget__icon" v-html="sidebarSvg.quotation"></span>
                <span>{{ $t('Quotation') }}</span>
            </h6>
        </div>
        <div class="card-body p-0 quotation-widget__body">
            <div class="table-responsive quotation-widget__table-wrap">
                <table class="table quotation-widget-table">
                    <thead>
                        <tr>
                            <th>{{ $t('Qtn Number') }}</th>
                            <th>{{ $t('Description') }}</th>
                            <th>{{ $t('Amount') }}</th>
                            <th>{{ $t('Status') }}</th>
                            <th class="dashboard-widget-table__actions">{{ $t('Actions') }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, key) in data.docs" :key="key">
                            <td class="quotation-widget-table__number">
                                <a :href="boqUrl + '/boq/' + item._id + '/quotation/item'" class="link-item-route text-capitalize">  {{item.quotationNumber}} {{item.quotationName}}</a>
                            </td>
                            <td>
                                <small>
                                    {{ item.remark || '-' }}
                                </small>
                            </td>
                            <td>
                               {{ projectInfo.currencyId.sign }}{{ ReformatNumber(item.amount) }}
                            </td>
                            <td class="quotation-widget-table__status">
                                <span :class="['quotation-widget-status', GetStatusClass(item.approvalStage)]">{{ApprovalStageBoqObj[item.approvalStage-1].name}}</span>
                            </td>
                            <td class="quotation-widget-table__actions dashboard-widget-table__actions">
                                <a
                                    v-if="permission.indexOf(ModuleActionList.BOQ_QUOTATION_EDIT)>-1 && Number(item.approvalStage) === 1"
                                    :href="boqUrl + '/boq/' + item._id + '/quotation/item?isEdit=true'"
                                    :title="$t('Edit')"
                                    :aria-label="$t('Edit')"
                                >
                                    <i class="fa-solid fa-pencil" aria-hidden="true"></i>
                                </a>
                                <a
                                    :href="boqUrl + '/boq/' + item._id + '/quotation/item'"
                                    :title="$t('View')"
                                    :aria-label="$t('View')"
                                >
                                    <i class="fa-regular fa-eye" aria-hidden="true"></i>
                                </a>
                            </td>
                        </tr>
                        
                        <tr v-if="data.docs.length==0">
                            <td class="text-center dashboard-widget__empty-state" colspan="5" >
                                {{ $t('No data Found') }}
                            </td>
                        </tr>
                    </tbody>
                </table>   
            </div>
            <div class="dashboard-widget__footer quotation-widget__footer" v-if="permission.indexOf(ModuleActionList.BOQ_QUOTATION_CREATE)>-1 || data.docs.length!=0">
                <a
                    v-if="permission.indexOf(ModuleActionList.BOQ_QUOTATION_CREATE)>-1"
                    class="btn dashboard-widget__button quotation-widget__add"
                    data-bs-target="#BoqModalAddQuotation"
                    data-bs-toggle="modal"
                    @click="()=>{ newQuotation = {};}"
                >
                    <i class="fa-solid fa-plus"></i> {{ $t('Add Quotation') }}
                </a>
                <span v-else></span>
                <a v-if="data.docs.length!=0" :href="boqUrl + '/boq/' + projectInfo._id + '/quotation/list'" class="dashboard-widget__link">{{ $t('View All') }}</a>
            </div>
        </div>
    </div>
    
</template>



<script>
import {GetQuotationList} from '@/actions/projectActions.js'
import {ReformatNumber, ReformatDate, ApprovalStageBoqObj, ModuleActionList} from '../../helpers/utilities.js'
import { mapGetters } from 'vuex'
import { sidebarSvg } from '@/components/deluxe/DeluxeSidebar.vue'
import 'dotenv/config'
export default {
    name : 'BillOfQuanitityListWidget',
    props : ['projectInfo'],
    data(){
        return {
            data : {
                docs : []
            },
            ApprovalStageBoqObj,
            newQuotation : {},
            qtnSaveClicked : false,
            isExecuting : false,
            boqUrl : process.env.VUE_APP_BOQ_URL,
            ModuleActionList,
            quotationList : [],
            sidebarSvg
        }
    },
    mounted : async function(){
        const self = this
        const response = await GetQuotationList({ id : self.projectInfo._id, page : 1, search : "", limit : 5})
        if(!response)
            return
        self.data = response
    },
    methods :{
        ReformatNumber,
        ReformatDate,
        GetStatusClass(approvalStage){
            const statusClasses = {
                1 : 'quotation-widget-status--draft',
                2 : 'quotation-widget-status--pending',
                3 : 'quotation-widget-status--reviewed',
                4 : 'quotation-widget-status--approval',
                5 : 'quotation-widget-status--published',
                6 : 'quotation-widget-status--revision',
                7 : 'quotation-widget-status--neutral'
            }
            return statusClasses[approvalStage] || 'quotation-widget-status--neutral'
        }
    },
    computed : {
        ...mapGetters(['permission'])
    }
    
} 
</script>

<style scoped>
.quotation-widget {
    border: 0;
    box-shadow: 0 0.75rem 1.75rem rgba(68, 43, 58, 0.08) !important;
}

.quotation-widget__header {
    border-bottom: 1px solid #c5468d !important;
    background: #edd1df !important;
    padding: 0.85rem 1rem;
}

.quotation-widget__header .dashboard-widget__title {
    color: #a00055 !important;
    font-size: 1.15rem;
}

.quotation-widget__header .dashboard-widget__icon {
    color: #a00055;
}

.quotation-widget__header .dashboard-widget__icon :deep(svg *) {
    stroke: currentColor !important;
}

.quotation-widget__body {
    padding: 0.85rem !important;
    background: #ffffff !important;
}

.quotation-widget__table-wrap {
    overflow-x: auto;
    border: 1px solid #c5468d !important;
    border-radius: 0.15rem !important;
    background: #ffffff;
    box-shadow: none;
}

.quotation-widget-table {
    min-width: 42rem;
    margin: 0;
    border-collapse: collapse;
    color: #1e1b16;
    font-family: "Albert Sans", Arial, sans-serif;
    font-size: 0.84rem;
}

.quotation-widget-table thead th {
    border: 0;
    border-bottom: 2px solid #c5468d !important;
    color: #a00055 !important;
    background: #edd1df !important;
    font-size: 0.78rem;
    font-weight: 800;
    line-height: 1.2;
    padding: 0.85rem 1rem;
}

.quotation-widget-table td {
    border: 0;
    color: #173129 !important;
    font-weight: 600;
    padding: 0.85rem 1rem;
    vertical-align: middle;
}

.quotation-widget-table tbody tr:nth-child(odd) td:nth-child(odd) {
    background: #fbf3f8 !important;
}

.quotation-widget-table tbody tr:nth-child(odd) td:nth-child(even) {
    background: #fff9fc !important;
}

.quotation-widget-table tbody tr:nth-child(even) td:nth-child(odd) {
    background: #e4e0e3 !important;
}

.quotation-widget-table tbody tr:nth-child(even) td:nth-child(even) {
    background: #ece8eb !important;
}

.quotation-widget-table__number {
    min-width: 12rem;
}

.quotation-widget-table__number a {
    color: #213c86 !important;
    font-weight: 800;
    text-decoration: none;
}

.quotation-widget-table__number a:hover,
.quotation-widget-table__number a:focus {
    color: #007bff !important;
    text-decoration: none;
}

.quotation-widget-table__status {
    text-align: center;
}

.quotation-widget-status {
    display: inline-flex;
    min-width: 5.25rem;
    min-height: 1.55rem;
    align-items: center;
    justify-content: center;
    border-radius: 999px;
    padding: 0.25rem 0.8rem;
    font-size: 0.74rem;
    font-weight: 800;
    line-height: 1;
    text-transform: capitalize;
    white-space: nowrap;
}

.quotation-widget-status--published,
.quotation-widget-status--reviewed {
    color: #249277;
    background: #d8ebe6;
}

.quotation-widget-status--draft {
    color: #b0005b;
    background: #f7e0ec;
}

.quotation-widget-status--pending {
    color: #d06b00;
    background: #fff0be;
}

.quotation-widget-status--approval {
    color: #0a6e9d;
    background: #d7edf7;
}

.quotation-widget-status--revision {
    color: #c43d3d;
    background: #f7dddd;
}

.quotation-widget-status--neutral {
    color: #777777;
    background: #eeeeee;
}

.quotation-widget-table__actions {
    white-space: nowrap;
    text-align: center;
}

.quotation-widget-table__actions a {
    display: inline-flex;
    width: 1.55rem;
    height: 1.55rem;
    align-items: center;
    justify-content: center;
    color: #777777 !important;
    font-size: 0.95rem;
    text-decoration: none;
}

.quotation-widget-table__actions a:hover,
.quotation-widget-table__actions a:focus {
    color: #a00055 !important;
    text-decoration: none;
}

.quotation-widget__add,
.quotation-widget__add:hover,
.quotation-widget__add:focus {
    min-height: 2.2rem;
    border: 0 !important;
    border-radius: 0 !important;
    color: #ffffff !important;
    background: #a00055 !important;
    font-size: 0.82rem;
}

.quotation-widget__footer {
    border-top: 0;
    padding: 0.9rem 0 0;
}

.quotation-widget .dashboard-widget__link {
    color: #a00055 !important;
    background: #f7e0ec;
}

@media (max-width: 767.98px) {
    .quotation-widget-table {
        min-width: 38rem;
    }

    .quotation-widget__body {
        padding: 0.75rem !important;
    }
}
</style>
